module.exports = __webpack_public_path__ + "static/media/YB5M01_0.bffe877a.jpg";